export const IMAGE_TYPES = ['image/gif', 'image/jpeg', 'image/pjpeg', 'image/png', 'image/svg+xml'];
export const COVER_IMAGE_TYPES = ['image/jpeg', 'image/pjpeg', 'image/png', 'image/svg+xml'];
export const DOC_TYPES = [
  'video/x-msvideo',
  'video/avi',
  'video/msvideo',
  'application/vnd.ms-wordml',
  'application/msword',
  'application/msword2',
  'application/msword5',
  '',
  'application/vnd.ms-word',
  'application/x-tika-msoffice',
  'application/x-tika-ooxml',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  'application/mspowerpoint',
  'application/x-mobipocket-ebook',
  'application/zip',
  'image/svg+xml',
  'image/svg',
  'image/jpeg',
  'image/pjpeg',
  'image/png',
  'image/gif',
  'image/pjpeg',
  'video/mp4',
  'video/quicktime',
  'application/quicktime',
  'application/pdf',
  'application/x-pdf',
  'application/epub+zip',
  'application/x-fictionbook+xml',
  '.mobi',
  '.fb2',
  'application/x-zip',
  'application/x-zip-compressed',
];
